import { Template, Unit } from 'ballerina-core'
import React, { ReactNode } from 'react'
import { pushDatalayer } from '../../seo/datalayer'
import { grantAllConsentTypes, grantMinimalConsentTypes } from '@shared/Frontend/seo/datalayer.consent'
import { setCookie } from '../../utils/cookies'
import {
  Accepted,
  analyticalCookies,
  Cookie,
  Cookies,
  cookies,
  functionalCookies,
  no,
  setConsentCookie,
  trackingCookies,
  videoCookies,
  yes,
} from '../../utils/hoppingerCookies'
import { CookiebarState, showCookies } from './cookiebar.state'


export type CookiebarView = {
  Cookiebar: (_: {
    showOptions: boolean
    toggleOptions: () => void
    onAcceptAll: () => void
    onDeclineAll: () => void
    onApplySettings: () => void
    onSetSingle: (cookie: Cookie, state: Accepted) => void
    selectedCookieValues: Cookies
  }) => ReactNode
}

export const CookiebarTemplate = Template.Default<Unit, CookiebarState, Unit, CookiebarView>(
  ({ context, setState, view }) =>
    context.visible ? (
      <view.Cookiebar
        onAcceptAll={() => {
          grantAllConsentTypes()
          pushDatalayer({ category: 'all_cookies', action: 'accept', label: window.location.href })
          setState(allCookiesUpdater(yes))
          setCookie(showCookies, no)
          cookies.forEach((cookie) => setCookie(cookie, yes))
          location.reload()
        }}
        onDeclineAll={() => {
          grantMinimalConsentTypes()
          pushDatalayer({ category: 'all_cookies', action: 'decline', label: window.location.href })
          setState(allCookiesUpdater(no))
          setCookie(showCookies, no)
          cookies.forEach((cookie) => setCookie(cookie, no))
          location.reload()
        }}
        onApplySettings={() => {
          pushDatalayer({ category: 'cookies', action: 'accept some', label: window.location.href })
          cookies.forEach((cookie) => setConsentCookie(cookie, context.selectedCookies[cookie]))
          setCookie(showCookies, no)
          setState((state): CookiebarState => ({ ...state, cookies: state.selectedCookies, visible: false }))
          location.reload()
        }}
        onSetSingle={(name, value) => 
          setState(
            (state): CookiebarState => ({ ...state, selectedCookies: { ...state.selectedCookies, [name]: value } })
          )
        }
        showOptions={context.expandOptions}
        toggleOptions={() => setState((state): CookiebarState => ({ ...state, expandOptions: !state.expandOptions }))}
        selectedCookieValues={context.selectedCookies}
      />
    ) : (
      <></>
    )
)

const allCookiesUpdater =
  (accepted: Accepted) =>
  (state: CookiebarState): CookiebarState => {
    const updatedCookies = {
      [functionalCookies]: accepted,
      [analyticalCookies]: accepted,
      [videoCookies]: accepted,
      [trackingCookies]: accepted,
    }
    return { ...state, cookies: updatedCookies, selectedCookies: updatedCookies, visible: false }
  }
